import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PdfViewerComponent } from '@app-shared/components/pdf-viewer/pdf-viewer.component';
import * as moment from 'moment';
import { HelperService } from 'src/app/core/services/helper.service';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';

@Component({
  selector: 'app-course-batch-card',
  templateUrl: './course-batch-card.component.html',
  styleUrls: ['./course-batch-card.component.css']
})
export class CourseBatchCardComponent implements OnInit {

  @Input() batchData: any = null;

  @Input() dataType: any = null;

  constructor(private dialog: MatDialog,public _helper: HelperService,) { }

  ngOnInit(): void {
  }
  openSession = () => {
    // const config: MatDialogConfig = {
    //   data: this.batchData.schedule,
    //   disableClose: false,
    //   scrollStrategy: new NoopScrollStrategy()
    // };
    // const dialogRef = this.dialog.open(PdfViewerComponent, config);
    // dialogRef.afterOpened().subscribe(()=>{
    //   document.body.classList.add('modal-open');
    // });

    // dialogRef.afterClosed().subscribe((res: any) => {
    //   document.body.classList.remove('modal-open');
    // })
    this.batchData.src = this.batchData.schedule
    this.batchData.format = 'application/pdf'
    const config: MatDialogConfig = {
      data: {
        item: this.batchData,
        isAudio: false,
        isVideos:false,
        isDocuments: true,
        isPresentations: false,
      },
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      panelClass: 'doc-viewer-popup'
    };

    const dialogRef = this.dialog.open(DocumentViewerComponent, config);

    dialogRef.afterOpened().subscribe(()=>{
      document.body.classList.add('modal-open');
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
    })
  }

}
